import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertDialogComponent } from '../dialog/dialog';

export const forwardComponentRef = forwardRef(() => EditInputComponent);

@Component({
	selector: 'edit-input',
	templateUrl: './edit_input.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardComponentRef,
			multi: true
		}
	]
})
export class EditInputComponent implements ControlValueAccessor {

	model: string;

	editing?: boolean;
	disabled = false;

	@Input()
	type: string = "text";

	@Input()
	minlength: number = null;

	@Input()
	maxlength: number = null;

	@Input()
	pattern: string = null;

	@Input()
	required: boolean | string = false;

	formGroup = new FormGroup({ editInput: new FormControl() });

	private changed = (value) => { };
	private touched = () => { };

	constructor(public modalService: NgbModal) { }

	private update(value) {
		this.stopEditing();
		this.changed(value);
	}

	private startEditing() {
		this.editing = true;
	}

	private stopEditing() {
		delete this.editing;
		this.touched();
	}

	get value() {
		return this.model;
	}

	writeValue(value: any): void {
		this.model = value;
	}

	registerOnChange(fn: any): void {
		this.changed = fn;
	}

	registerOnTouched(fn: any): void {
		this.touched = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
		if (isDisabled) {
			this.stopEditing();
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/edit_input/edit_input.component.ts